import React, { useContext } from "react";

import { HandlerContext } from "components/lnb/LnbWrapper";

function ListItem({ title, count, info }) {
    const handlerContext = useContext(HandlerContext);

    const handleClickListItem = () => {
        handlerContext.clickMenuTypeCodeEXT_LINK(info);
    };

    return (
        <div className="startbox clear" onClick={handleClickListItem}>
            <div className="startTxt fl">{title}</div>
            <div className="start fr">{count}개</div>
        </div>
    );
}

export default ListItem;
